define('commons/cache-widget',[ 'jquery', 'd3js', 'commons/message-manager'], function($, d3, messages) {

    var CacheWidget = function(containerSelector, options) {
        // Configuration settings
        this.settings = $.extend(true, {
            className : 'cache-widget',
            name: '',
            enabled: false,
            size: 0,
            capacity: 0,
            entity: '',
            width: 250,
            icon: {
                enabled: {
                    on: 'fa fa-check-square-o',
                    off: 'fa fa-square-o'
                },
                search: 'fa fa-search',
                capacity: 'fa fa-tasks fa-rotate-270',
                invalidateAll:  'fa fa-remove'
            },
            margin: {
                top: 30,
                right: 5,
                bottom: 30,
                left: 5
            },
            cacheStatBar: {
                height: 145,
                rangePadding: 60, // in %
                bottomPadding: 0
            },
            cacheSizeBar: {
                height: 145,
                rangePadding: 60 // in %
            },
            data : null
        }, options);
        
        var width = this.settings.width;
        var name = this.settings.name;
        var entity = this.settings.entity;
        var enabled = this.settings.enabled;
        var captionOffset = -20;
        var bottomPadding = 75 + this.settings.cacheStatBar.bottomPadding;
        
        // Size and capacity
        this.size = this.settings.size;
        this.capacity = this.settings.capacity;
        
        var $title = $('<div></div>').text(this.settings.name).attr('class', 'title');
        $('<span></<span>').attr('class', 'entity').text(this.settings.entity).appendTo($title);
        // Get the chart container
        this.$container = $('<div></div>').attr('class', this.settings.className).css('position', 'relative').appendTo($(containerSelector)).append($title);
        
        // Cache statistics scales + axis
        this.cacheStatScaleX = d3.scale.ordinal().rangeRoundBands([0, width], Math.min(100, this.settings.cacheStatBar.rangePadding) / 100).domain(['evictionCount', 'missCount', 'hitCount']);
        this.cacheStatXAxis = d3.svg.axis().scale(this.cacheStatScaleX).orient("bottom");
        this.cacheStatScaleY = d3.scale.linear().rangeRound([this.settings.cacheStatBar.height, 0]);
        
        // Cache size scales + axis
        this.cacheSizeScaleX = d3.scale.ordinal().rangeRoundBands([0, width], Math.min(100, this.settings.cacheSizeBar.rangePadding) / 100, 0);
        this.cacheSizeXAxis = d3.svg.axis().scale(this.cacheSizeScaleX).orient('bottom');
        this.cacheSizeScaleY = d3.scale.linear().range([this.settings.cacheSizeBar.height, 0]).domain([0, 100]);
        
        // Create the svg node
        var $svgContainer = $('<div></div>').attr('class', 'svg').appendTo(this.$container);
        var svg = d3.select($svgContainer.get(0)).append('svg')
        .attr('width', width + this.settings.margin.left + this.settings.margin.right)
        .attr('height', this.settings.cacheStatBar.height + bottomPadding + this.settings.cacheSizeBar.height + this.settings.margin.top + this.settings.margin.bottom)
        .append('g').attr('transform', 'translate(' + this.settings.margin.left + ',' + this.settings.margin.top + ')');
        
        // Create containers
        this.cacheStatBar = svg.append('g').attr('class', 'stat-bar');
        this.cacheStatXAxisContainer = this.cacheStatBar.append('g').attr('class', 'axis').attr('transform', 'translate(0,' + this.settings.cacheStatBar.height + ')');
        this.cacheSizeBar = svg.append('g').attr('class', 'size-bar').attr('transform', 'translate(0,' + (this.settings.cacheStatBar.height + bottomPadding) + ')');
        this.cacheSizeXAxisContainer = this.cacheSizeBar.append('g').attr('class', 'axis').attr('transform', 'translate(0,' + this.settings.cacheSizeBar.height + ')');
        
        // Captions
        this.cacheStatBar.append('text').attr('class', 'caption').text('Cache statistics').attr('dy', captionOffset);
        this.cacheSizeBar.append('text').attr('class', 'caption').text('Cache size per segment').attr('dy', captionOffset);
        
        // Bottom toolbar
        this.$toolbar = $('<div></div>').attr('class', 'tool-bar').appendTo(this.$container).css('display', 'none');
        
        // Enable cache checkbox
        this.$enabled = $('<i></i>').click($.proxy(function(e) {
            var $node = $(e.currentTarget);
            var enabled = !$node.data('enabled');
            if(confirm('You are about to ' + (enabled ? 'enable' : 'disable') + ' cache for entity ' + name + ', continue?')) {
                $.ajax('/debug/cache/enable', {
                    type: 'POST',
                    context: this,
                    data: {
                        'enable': enabled,
                        'entity': entity
                    }
                }).done(function(data) {
                    messages.info('Cache ' + name + ' has been successfully ' + (enabled ? 'enabled' : 'disabled'));
                    this._updateEnabledInfo(enabled);
                }).fail(function() {
                    messages.error('An error occured trying to ' + (enabled ? 'enable' : 'disable') + ' the cache for entity ' + name);
                });
            }
        }, this)).appendTo(this.$toolbar);
        this._updateEnabledInfo(enabled);
        
        
        // Cache search panel
        this.$searchPanel = $('<div></div>').addClass('search-panel').appendTo($svgContainer).bind('otransitionend transitionend webkitTransitionEnd', $.proxy(function(e) {
            if($(e.currentTarget).hasClass('open')) {
                this.$searchInput.focus();
            }
        }, this));
        this.$searchInput = $('<input/>').attr('type', 'text').attr('placeholder', 'Enter id...').appendTo($('<div></div>').addClass('search-top').appendTo(this.$searchPanel));
        this.$searchResultList = $('<div></div>').addClass('result-list').appendTo(this.$searchPanel);
        this.$searchInput.keyup($.proxy(function(e) {
            var search = $(e.currentTarget).val();
            switch(e.which) {
                case 13:
                    if(search.length > 0) {
                        this._search(search, entity);
                    }
                    break;
                case 27:
                    this._resetSearchPanel();
                    break;
                default:
            }
            if(search.length == 0) {
                this.$searchResultList.empty();
            }
        }, this));
        
        // Cache icon
        $('<i></i>').attr('title', 'Search for a value on cache').addClass(this.settings.icon.search + ' search-icon icon-button').click($.proxy(function() {
            this._resetSearchPanel();
        }, this)).appendTo(this.$toolbar);
        
        // Invalidate-all button
        $('<i></i>').attr('title', 'Invalidate all').addClass(this.settings.icon.invalidateAll + ' invalidate-all-icon icon-button').click($.proxy(function() {
        	 $.ajax('/debug/cache/invalidate-all', {
                 type: 'POST',
                 context: this,
                 data: {
                     'entity': entity
                 }
             }).done(function(data) {
                 messages.info('Successfully invalidate all entries of ' + name);
             }).fail(function() {
                 messages.error('An error occured trying to invalidate all entries of ' + name);
             });
        }, this)).appendTo(this.$toolbar);
        
        // Capacity text
        this.$capacity = $('<span></span>').attr('class', 'capacity').appendTo(this.$toolbar);
        this._updateCapacityLabel();
        
        // Capacity button
        $('<i></i>').attr('title', 'Change capacity').addClass(this.settings.icon.capacity + ' capacity-icon icon-button').click($.proxy(function() {
            var value = prompt('You are about to change the cache capacity to the given new value, continue?', this.capacity);
            var v = parseInt(value);
            var oldCapacity = this.capacity;
            if(v > 0 && this.capacity !== v) {
                this.capacity = v;
                $.ajax('/debug/cache/capacity', {
                    type: 'POST',
                    context: this,
                    data: {
                        'capacity': this.capacity,
                        'entity': entity
                    }
                }).done(function(data) {
                    this._updateCapacityLabel();
                    messages.info('Successfully change the cache capacity of ' + name + ' to ' + this.capacity);
                }).fail(function() {
                    this.capacity = oldCapacity;
                    messages.error('An error occured trying to update the cache capacity of ' + name);
                });
            }
        }, this)).appendTo(this.$toolbar);
        
        if(this.settings.data) {
            this.update(enabled, this.settings.data);
        }
        
    };
    
    CacheWidget.prototype._search = function(search, entity) {
        this.$searchInput.attr('disabled', 'disabled');
        $.ajax('/debug/cache/search', {
            type: 'GET',
            context: this,
            data: {
                'search': search,
                'entity': entity
            }
        }).done(function(result) {
            var html = this._updateSearchResult(result);
            var $node = null;
            if(html.length < 1) {
                $node = $('<div></div>').addClass('empty-result').text('No result');
            } else {
                $node = $('<ul></ul>').html(html);
            }
            $node.appendTo(this.$searchResultList.empty());
        }).fail(function() {
            messages.error('An error occured searching for a cache value');
        }).complete(function() {
            this.$searchInput.removeAttr('disabled').focus();
        });
    };
    
    CacheWidget.prototype._updateSearchResult = function(data) {
        var html = "";
        for(var p in data) {
            var v = data[p];
            switch($.type(v)) {
                case 'boolean':
                case 'number':
                case 'string':
                case 'date':
                case 'regexp':
                    html += '<li><span>' + p + ': </span>' + v + '</li>';
                    break;
                case 'array':
                case 'object':
                    html += '<li><span>' + p + ': </span><ul>';
                    html += this._updateSearchResult(v);
                    html += '</li></ul>';
                    break;
                default:
                    // Don't process Functions and Errors objects
            }
        }
        return html;
    };
    
    CacheWidget.prototype._resetSearchPanel = function() {
        this.$searchPanel.toggleClass('open');
        this.$searchInput.val('');
        this.$searchResultList.empty();
    };
    
    CacheWidget.prototype._updateEnabledInfo = function(enabled) {
        this.$enabled.data('enabled', enabled);
        this.$enabled.attr('title', enabled ? 'Cache is enabled. Click to disable it' : 'Cache is disabled. Click to enable it');
        this.$enabled.get(0).className = "";
        this.$enabled.addClass((enabled ? this.settings.icon.enabled.on : this.settings.icon.enabled.off) + ' enabled-icon icon-button');
    };
    
    CacheWidget.prototype._updateCapacityLabel = function() {
        this.$capacity.text(this.size + ' / ' + this.capacity);
    };
    
    /**
     * Data: [{
     *     hitCount: 0,
     *     missCount: 0,
     *     evictionCount: 0,
     *     capacity: 0,
     *     size: 0
     * }, {...}]
     */
    CacheWidget.prototype.update = function(enabled, data) {
        var cacheStatBarHeight = this.settings.cacheStatBar.height;
        var cacheStatScaleX = this.cacheStatScaleX;
        var cacheStatScaleY = this.cacheStatScaleY;
        var cacheSizeScaleX = this.cacheSizeScaleX;
        var cacheSizeScaleY = this.cacheSizeScaleY;
        
        var size = 0;
        var capacity = 0;
        var maxStatDomain = 0;
        var stats = [{name: 'evictionCount', c: 0}, {name: 'missCount', c: 0}, {name: 'hitCount', c: 0}];
        data.forEach(function(d1) {
            size += d1.size;
            capacity += d1.capacity;
            stats.forEach(function(d2) {
                d2.c += d1[d2.name];
                maxStatDomain = Math.max(maxStatDomain, d2.c);
            });
        });
        
        this.size = size;
        this.capacity = capacity;
        this._updateCapacityLabel();
        
        // Update enabled
        this._updateEnabledInfo(enabled);
        
        // Update domains
        cacheStatScaleY.domain([0, maxStatDomain]);
        cacheSizeScaleX.domain(d3.range(0, data.length));
        
        // Functions
        var cacheStatScaleXFn = function(d) {
            return cacheStatScaleX(d.name);
        };
        var cacheSizeScaleXFn = function(d, i) {
            return cacheSizeScaleX(i);
        };

        var cacheStatScaleYFn = function(d) {
            return cacheStatScaleY(d.c) + + (this.nodeName == 'text' ? -4 : 0);
        };
        var cacheSizeScaleYFn = function(d) {
            return d.capacity == 0 ? 0 : cacheSizeScaleY(d.size / d.capacity * 100) + (this.nodeName == 'text' ? -4 : 0);
        };
        
        var cacheStatBarHeightFn = function(d) {
            return cacheStatBarHeight - cacheStatScaleY(d.c);
        };
        var cacheSizeBarHeightFn = function(d) {
            return d.capacity == 0 ? 0 : cacheSizeScaleY(100 - (d.size / d.capacity * 100));
        };
        
        var cacheStatBarTextFn = function(d) {
            return d.c;
        };
        var cacheSizeBarTextFn = function(d) {
            return d.size;
        };
        
        // Update
        this.cacheStatXAxisContainer.call(this.cacheStatXAxis);
        this.cacheSizeXAxisContainer.call(this.cacheSizeXAxis.tickFormat(function(i) {
            var d = data[i];
            return (d.capacity == 0 ? 0 :(d.size / d.capacity * 100).toFixed(1)) + ' %';
        }));
        var cacheStatBarRect = this.cacheStatBar.selectAll('rect').data(stats).attr('y', cacheStatScaleYFn).attr('height', cacheStatBarHeightFn);
        var cacheSizeBarRect = this.cacheSizeBar.selectAll('rect').data(data).attr('y', cacheSizeScaleYFn).attr('height', cacheSizeBarHeightFn);
        var cacheStatBarText = this.cacheStatBar.selectAll('.text').data(stats).attr('y', cacheStatScaleYFn).text(cacheStatBarTextFn);
        var cacheSizeBarText = this.cacheSizeBar.selectAll('.text').data(data).attr('y', cacheSizeScaleYFn).text(cacheSizeBarTextFn);
        
        // First creation
        cacheStatBarRect.enter().append('rect')
        .attr('class', function(d) {
            return d.name;
        })
        .attr('x', cacheStatScaleXFn)
        .attr('width', cacheStatScaleX.rangeBand())
        .attr('y', cacheStatScaleYFn)
        .attr('height', cacheStatBarHeightFn);
        
        cacheStatBarText.enter().append('text')
        .attr('class', 'text')
        .attr('x', function(d) {
            return cacheStatScaleXFn(d) + cacheStatScaleX.rangeBand() / 2;
        })
        .attr('y', cacheStatScaleYFn)
        .text(cacheStatBarTextFn);
        
        cacheSizeBarRect.enter().append('rect')
        .attr('x', cacheSizeScaleXFn)
        .attr('width', cacheSizeScaleX.rangeBand())
        .attr('y', cacheSizeScaleYFn)
        .attr('height', cacheSizeBarHeightFn);
        
        cacheSizeBarText.enter().append('text')
        .attr('class', 'text')
        .attr('x', function(d, i) {
            return cacheSizeScaleXFn(d, i) + cacheSizeScaleX.rangeBand() / 2;
        })
        .attr('y', cacheSizeScaleYFn)
        .text(cacheSizeBarTextFn);
        
        // Remove elements if needed
        cacheStatBarRect.exit().remove();
        cacheStatBarText.exit().remove();
        cacheSizeBarRect.exit().remove();
        cacheSizeBarText.exit().remove();
        
        this.$toolbar.css('display', 'block');
    };

    return CacheWidget;

});
